export const blogTitle = `Blog about Full-cycle app development | Lunka.tech`;
export const worksTitle = `Portfolio | Lunka Tech`;
export const homeTitle = 'Full-Cycle App Development Company | Lunka Tech';
export const aboutUsTitle = 'About Company Lunka Tech | Lunka Tech';
export const contactUsTitle = 'Contact Us Lunka Tech Company | Lunka Tech';
export const authorTitle = ' Author | Lunka Tech';
export const supportUkraineTitle = ' Lunka stands with Ukraine | Lunka Tech';
